import { render, staticRenderFns } from "./DeviceMoveModal.vue?vue&type=template&id=247beb39&scoped=true&"
import script from "./DeviceMoveModal.vue?vue&type=script&lang=ts&"
export * from "./DeviceMoveModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247beb39",
  null
  
)

export default component.exports